export var ResidenceProofType;
(function (ResidenceProofType) {
    ResidenceProofType["ID_WITH_GERMAN_ADDRESS"] = "ID_WITH_GERMAN_ADDRESS";
    ResidenceProofType["MELDEBESCHEINIGUNG"] = "MELDEBESCHEINIGUNG";
    ResidenceProofType["NONE"] = "NONE";
})(ResidenceProofType || (ResidenceProofType = {}));
export var ResidenceGateStatus;
(function (ResidenceGateStatus) {
    ResidenceGateStatus["PASSED_SELF_DECLARED"] = "PASSED_SELF_DECLARED";
    ResidenceGateStatus["DOCUMENT_UPLOADED"] = "DOCUMENT_UPLOADED";
    ResidenceGateStatus["PENDING_DOCUMENT"] = "PENDING_DOCUMENT";
    ResidenceGateStatus["REJECTED_NON_RESIDENT"] = "REJECTED_NON_RESIDENT";
})(ResidenceGateStatus || (ResidenceGateStatus = {}));
export var ResidenceReviewStatus;
(function (ResidenceReviewStatus) {
    ResidenceReviewStatus["UNDER_REVIEW"] = "UNDER_REVIEW";
    ResidenceReviewStatus["ACCEPTED"] = "ACCEPTED";
    ResidenceReviewStatus["REJECTED"] = "REJECTED";
})(ResidenceReviewStatus || (ResidenceReviewStatus = {}));
export const RESIDENCE_KYC_UNLOCK_STATUSES = [
    ResidenceGateStatus.PASSED_SELF_DECLARED,
    ResidenceGateStatus.DOCUMENT_UPLOADED,
];
export const isResidenceGateKycUnlocked = (gate) => !!gate && RESIDENCE_KYC_UNLOCK_STATUSES.includes(gate.status);
export const residenceReviewPending = (gate) => !!gate?.documentFileId && gate.reviewStatus !== ResidenceReviewStatus.ACCEPTED;
//# sourceMappingURL=residence.types.js.map